import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getActiveTab = (state: ContentPluginRootState) => state.data.activeTab;

export default getActiveTab;
